export default __webpack_public_path__ + "static/page-header-do-1-2f0ecf8fb6860a6e40ad7731ab4978d8.png";